import {FC} from 'react';

import rksLogo from '../../assets/docLogo.svg';

interface IADPUDocTemplate {
  data: any;
}

export const ADPUDocTemplate: FC<IADPUDocTemplate> = (props) => {
  return (
    <div
      id="adpu-doc"
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 'auto',
        fontSize: '16px',
        padding: '0 10px',
        height: '1700px',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: 'fit-content',
          transform: `scale(0.565) scaleX(155%) scaleY(1.1) rotateZ(90deg) translateX(-625px) translateY(30px)`,
        }}
      >
        <header>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              borderBottom: '1px solid black',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              paddingBottom: '2px',
              marginBottom: '2px',
            }}
          >
            <img src={rksLogo} style={{paddingLeft: '30px', position: 'relative', bottom: '-44px'}} alt="" />
            <div style={{display: 'flex', flex: 0.95, flexDirection: 'column', fontSize: '18px'}}>
              <p style={{margin: 0, textWrap: 'wrap'}}>Гарантирующий поставщик ООО «РКС-энерго»</p>
              <p style={{margin: 0, textWrap: 'wrap'}}>
                <b>Юридический адрес:</b> ул. Жука, д.3, пом. 204, Шлиссельбург, Кировский район, Ленинградская область,
                Российская Федерация, 187320
              </p>
              <p style={{margin: 0, textWrap: 'wrap'}}>
                <b>Почтовый адрес:</b> 194044, г. Санкт-Петербург, Финляндский пр., д. 4 а, офисы 136-158.
                <br />
                Тел./факс: (812) 244-70-64. E-mail: office@rks-energo.ru
              </p>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', borderTop: '1px solid black'}}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '5px',
              }}
            >
              <h4 style={{fontSize: '18px', margin: 0, display: 'inline-flex', flexDirection: 'row'}}>
                <b>Акт демонтажа, установки (замены), допуска (ввода) в эксплуатацию прибора учета</b>
              </h4>
              <h4 style={{fontSize: '18px', margin: 0, display: 'inline-flex', flexDirection: 'row'}}>
                <b style={{display: 'inline-flex', flexDirection: 'row'}}>
                  электрической энергии №&nbsp;
                  {props.data.contentDevicenumber ? (
                    <p style={{minWidth: '150px', textAlign: 'center', margin: 0, borderBottom: '1px solid black'}}>
                      {props.data.contentDevicenumber}
                    </p>
                  ) : (
                    '______________________'
                  )}
                </b>
              </h4>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <p>
              «
              <span
                style={{width: '48px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.day}
              </span>
              » &nbsp;&nbsp;
              <span
                style={{width: '54px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.month}
              </span>
              &nbsp;20
              <span
                style={{width: '36px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.year}
              </span>
              &nbsp;г.
            </p>
            <p>
              «
              <span
                style={{width: '36px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.hours}
              </span>
              »&nbsp;&nbsp;часов&nbsp;«
              <span
                style={{width: '30px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.minutes}
              </span>
              »&nbsp;&nbsp;минут
            </p>
          </div>
        </header>
        <main>
          <div>
            <div>
              <p>
                Составлен представителем гарантирующего поставщика ООО «ЭМС», действующим на основании доверенности
                №&nbsp;
                <span
                  style={{
                    width: '148px',
                    display: 'inline-block',
                    textAlign: 'center',
                    borderBottom: '1px solid black',
                  }}
                >
                  147-1/2024
                </span>
                &nbsp;от&nbsp;«
                <span
                  style={{width: '20px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
                >
                  16
                </span>
                »&nbsp;
                <span
                  style={{width: '36px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
                >
                  мая
                </span>
                &nbsp;2024г.
              </p>
            </div>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <p style={{margin: 0, display: 'inline-flex', flexDirection: 'row', alignItems: 'center'}}>
                в лице:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{margin: 0, width: '90%', borderBottom: '1px solid black', fontSize: '16px'}}>
                  {props.data.userFio}
                </span>
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: '16px',
                  display: 'inline-flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                }}
              >
                <i>(должность, ФИО)</i>
              </p>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: '5px',
              alignItems: 'flex-end',
            }}
          >
            <p style={{margin: 0, display: 'inline-block', width: '145px', textWrap: 'wrap'}}>
              в отношении <b>потребителя</b>
            </p>
            <p
              style={{
                margin: 0,
                display: 'inline-block',
                height: 'fit-content',
                flex: 0.45,
                borderBottom: '1px solid black',
                fontSize: '16px',
              }}
            >
              {props.data.customer}
            </p>
            <p style={{margin: 0}}>
              <b>лицевой счёт</b>
            </p>
            <p style={{margin: 0, flex: 0.45, borderBottom: '1px solid black', fontSize: '16px'}}>
              {props.data.idLicAccount}
            </p>
          </div>
          <div style={{display: 'flex', flexDirection: 'column', marginTop: '5px'}}>
            <p style={{display: 'inline-flex', flexDirection: 'row', gap: '10px'}}>
              по адресу:
              <span style={{margin: 0, display: 'inline-flex', flex: 0.45, justifyContent: 'space-between'}}>
                <b>нас. пункт</b>
                <span
                  style={{margin: 0, flex: 0.8, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}
                >
                  {props.data.city}
                </span>
              </span>
            </p>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <p style={{margin: 0}}>
                <b>ул.</b>
              </p>
              <p style={{margin: 0, flex: 0.35, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}>
                {props.data.street}
              </p>
              <p style={{margin: 0}}>
                <b>д.</b>
              </p>
              <p style={{margin: 0, flex: 0.15, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}>
                {props.data.house}
              </p>
              <p style={{margin: 0}}>
                <b>корп.</b>
              </p>
              <p
                style={{margin: 0, flex: 0.1, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}
              ></p>
              <p style={{margin: 0}}>
                <b>кв.</b>
              </p>
              <p style={{margin: 0, flex: 0.15, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}>
                {' '}
                {props.data.apartment}
              </p>
              <p style={{margin: 0}}>
                <b>комн.</b>
              </p>
              <p
                style={{margin: 0, flex: 0.1, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}
              ></p>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: '5px',
            }}
          >
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '49%'}}>
              <p style={{margin: 0}}>
                <b>телефон потребителя:</b>
              </p>
              <p style={{margin: 0, flex: 0.9, borderBottom: '1px solid black', fontSize: '16px'}}>
                {props.data.customerPhone}
              </p>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '49%'}}>
              <p style={{margin: 0}}>
                <b>e-mail потребителя:</b>
              </p>
              <p style={{margin: 0, flex: 0.9, borderBottom: '1px solid black'}}>{props.data.email}</p>
            </div>
          </div>
          <p style={{margin: '2px 0', fontSize: '16px'}}>Характеристики и показания прибора учета электроэнергии:</p>
          <div style={{width: '100%', height: 'fit-content'}}>
            <table style={{border: '1px solid black', borderCollapse: 'collapse', fontSize: '15px', width: '100%'}}>
              <thead>
                <tr style={{width: '100%'}}>
                  <th
                    style={{
                      width: '33%',
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '6px 0',
                      backgroundColor: '#f2f2f2',
                    }}
                  ></th>
                  <th
                    style={{
                      width: '33%',
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '6px 0',
                      backgroundColor: '#f2f2f2',
                    }}
                  >
                    Демонтирован ИПУ
                  </th>
                  <th
                    style={{
                      width: '33%',
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '6px 0',
                      backgroundColor: '#f2f2f2',
                    }}
                  >
                    Установлен ИПУ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Место установки
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.taskLocation}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.taskLocation}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Балансовая принадлежность
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    ООО «РКС - энерго»
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Тип
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.devicename}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    Милур 107S.22 - GRZ - 1L - DT
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Заводской номер
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.devicenumber}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentDevicenumber}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Класс точности
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    0.5S
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Показания
                  </td>
                  <td style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                    <span style={{display: 'inline-flex', width: '100%', flexWrap: 'nowrap'}}>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '40%',
                        }}
                      >
                        ∑: {props.data.contentSummaOld}
                      </span>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '35%',
                        }}
                      >
                        Т1: {props.data.contentT1Old}
                      </span>
                      <span style={{fontSize: '16px', padding: '3px', display: 'inline-block', width: '25%'}}>
                        Т2: {props.data.contentT2Old}
                      </span>
                    </span>
                  </td>
                  <td style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                    <span style={{display: 'inline-flex', width: '100%', flexWrap: 'nowrap'}}>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '40%',
                        }}
                      >
                        ∑: {props.data.contentSumma}
                      </span>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '35%',
                        }}
                      >
                        Т1: {props.data.contentT1}
                      </span>
                      <span style={{fontSize: '16px', padding: '3px', display: 'inline-block', width: '25%'}}>
                        Т2: {props.data.contentT2}
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Разрядность (до и после запятой)
                  </td>
                  <td style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                    <span style={{display: 'inline-flex', width: '100%', flexWrap: 'nowrap'}}>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '50%',
                        }}
                      >
                        До:
                      </span>
                      <span style={{fontSize: '16px', padding: '3px', display: 'inline-block', width: '50%'}}>
                        После:
                      </span>
                    </span>
                  </td>
                  <td style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                    <span style={{display: 'inline-flex', width: '100%', flexWrap: 'nowrap'}}>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '50%',
                        }}
                      >
                        До: 6
                      </span>
                      <span style={{fontSize: '16px', padding: '3px', display: 'inline-block', width: '50%'}}>
                        После: 2
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Год выпуска
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.productdate}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.contentProductdate}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Дата поверки
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.lastControlDate}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.contentLastControlDate}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Дата следующей поверки
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.nextControlDate}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.contentNextControlDate}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Iном, А / Uном, В
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    5(100) / А 230 В
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Пломба №
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.contentSealnumberOld}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.contentSealnumber}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Организация, установившая пломбу
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    ООО «РКС - энерго»
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    № телефона SIM карты{' '}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentSimNumber}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                border: '1px solid black',
                borderTop: 0,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  flex: 0.265,
                  paddingLeft: '7.5px',
                }}
              >
                <span>
                  <b>Причина замены (установки):</b>
                </span>
              </div>
              <div style={{display: 'flex', flexDirection: 'column', flex: 0.6}}>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  <input style={{height: '20px', width: '20px'}} type="checkbox" />
                  <p style={{margin: 0}}>истечение МПИ&nbsp;</p>
                  <input style={{height: '20px', width: '20px'}} type="checkbox" />
                  <p style={{margin: 0}}>выход из строя&nbsp;</p>
                  <input style={{height: '20px', width: '20px'}} type="checkbox" />
                  <p style={{margin: 0}}>ПУ отсутствует&nbsp;</p>
                  <input style={{height: '20px', width: '20px'}} type="checkbox" />
                  <p style={{margin: 0}}>иное:&nbsp;</p>
                </div>
                <span>п. 80(1) ПП №354 от 06.05.2011 и п. 136 ПП № 442 от 04.05.2012</span>
              </div>
            </div>
          </div>
          <div style={{marginTop: '10px'}}>
            <span>
              <p style={{margin: 0, fontSize: '16px'}}>
                <b>Решение о вводе в эксплуатацию:</b> Установленный прибор учета&nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" checked={true} />
                &nbsp;<b>соответствует</b>&nbsp;/&nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" />
                &nbsp;<b>не соответствует</b>&nbsp;требованиям, предъявляемым нормативными документами к средствам
                учета, и &nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" checked={true} />
                &nbsp;<b>принимается</b>&nbsp;/&nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" />
                &nbsp;<b>не может быть введен</b>&nbsp; в эксплуатацию по причине:
              </p>
            </span>
            <span>
              __________________________________________________________________________________________________________________________________
            </span>
          </div>
          <div>
            <span>
              <p style={{margin: 0, fontSize: '16px'}}>
                <b>Характеристики соответствия:</b>&nbsp;Пломбы поверителя на установленном приборе учета соответствуют
                оттиску в свидетельстве о поверке и (или) записи в паспорте (формуляре) средства измерений и месту
                установки контрольных пломб и знаков визуального контроля, установленных на день начала проверки.
              </p>
            </span>
          </div>
          <div>
            <span>
              <p style={{margin: 0, fontSize: '16px'}}>
                <b>Особые отметки:</b>&nbsp;Прибор учета &nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" checked={true} />
                &nbsp;<b>включен</b>&nbsp;/&nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" />
                &nbsp;<b>не включен</b>&nbsp; в ИСУЭ ООО «РКС-энерго».
              </p>
            </span>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <span style={{padding: '1px', display: 'inline-flex', alignItems: 'flex-end'}}>
                <p style={{margin: 0, fontSize: '16px'}}>
                  Электронная почта Потребителя для направления уведомления о присоединении прибора учета электрической
                </p>
              </span>
              <span
                style={{
                  padding: '1px',
                  display: 'inline-flex',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between',
                }}
              >
                <p style={{margin: 0, flex: 0.5}}>
                  энергии к интеллектуальной системе учета электрической энергии (мощности)
                </p>
                <p style={{margin: 0, borderBottom: '1px solid black', flex: 0.45}}></p>
              </span>
            </div>
            <span>
              <p style={{margin: 0, fontSize: '16px'}}>В ходе проверки производилась фото / видеофиксация.</p>
            </span>
          </div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
              <p style={{margin: 0}}>
                <b>Представитель ООО «РКС-энерго»</b>
              </p>
              <div style={{width: '60%'}}>
                <span
                  style={{
                    width: '100%',
                    borderBottom: '1px solid black',
                    display: 'inline-flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <p style={{margin: 0}}>
                    <b>
                      (&nbsp;&nbsp;
                      {props.data.userFio
                        .split(' ')
                        .map((i: any, index: any) => (index !== 0 ? i[0] + '.' : i))
                        .join(' ')}
                      &nbsp;&nbsp;)
                    </b>
                  </p>
                </span>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '16px'}}>
                      <i>(подпись)</i>
                    </p>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '16px'}}>
                      <i>(расшифровка подписи, ФИО)</i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <p style={{margin: 0, textWrap: 'balance'}}>
                  <b>Представитель исполнителя коммунальных услуг</b>
                </p>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '16px'}}>
                    <i>(при участии)</i>
                  </p>
                </div>
              </div>
              <div style={{width: '60%'}}>
                <span
                  style={{
                    width: '100%',
                    borderBottom: '1px solid black',
                    display: 'inline-flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <p style={{margin: 0, letterSpacing: 3}}>
                    <b>
                      (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                    </b>
                  </p>
                </span>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '16px'}}>
                      <i>(подпись)</i>
                    </p>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '16px'}}>
                      <i>(расшифровка подписи, ФИО)</i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span>
            <p style={{margin: '4px 0 0 0'}}>
              Один экземпляр акта получил, демонтированный прибор учета получил, порядок снятия показаний разъяснен.
            </p>
          </span>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <p style={{margin: 0}}>
              <b>Потребитель (представитель)</b>
            </p>
            <div style={{width: '60%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  height: '16px',
                }}
              >
                <p style={{margin: 0, fontSize: '16px'}}>
                  <b>(&nbsp;{props.data.customer}&nbsp;)</b>
                </p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '16px'}}>
                    <i>(подпись)</i>
                  </p>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '16px'}}>
                    <i>(расшифровка подписи, ФИО)</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px'}}>
            <p style={{margin: 0}}>Причина отказа от подписания акта:</p>
            <p style={{margin: 0}}>
              ___________________________________________________________________________________________
            </p>
          </div>
        </main>
      </div>
      <div
        style={{
          position: 'absolute',
          transform: 'scale(0.565) scaleX(155%) scaleY(1.1) rotateZ(90deg) translateX(880px) translateY(-60px)',
          width: 'fit-content',
        }}
      >
        <header>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              borderBottom: '1px solid black',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              paddingBottom: '2px',
              marginBottom: '2px',
            }}
          >
            <img src={rksLogo} style={{paddingLeft: '30px', position: 'relative', bottom: '-44px'}} alt="" />
            <div style={{display: 'flex', flex: 0.95, flexDirection: 'column', fontSize: '18px'}}>
              <p style={{margin: 0, textWrap: 'wrap'}}>Гарантирующий поставщик ООО «РКС-энерго»</p>
              <p style={{margin: 0, textWrap: 'wrap'}}>
                <b>Юридический адрес:</b> ул. Жука, д.3, пом. 204, Шлиссельбург, Кировский район, Ленинградская область,
                Российская Федерация, 187320
              </p>
              <p style={{margin: 0, textWrap: 'wrap'}}>
                <b>Почтовый адрес:</b> 194044, г. Санкт-Петербург, Финляндский пр., д. 4 а, офисы 136-158.
                <br />
                Тел./факс: (812) 244-70-64. E-mail: office@rks-energo.ru
              </p>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', borderTop: '1px solid black'}}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '5px',
              }}
            >
              <h4 style={{fontSize: '18px', margin: 0, display: 'inline-flex', flexDirection: 'row'}}>
                <b>Акт демонтажа, установки (замены), допуска (ввода) в эксплуатацию прибора учета</b>
              </h4>
              <h4 style={{fontSize: '18px', margin: 0, display: 'inline-flex', flexDirection: 'row'}}>
                <b style={{display: 'inline-flex', flexDirection: 'row'}}>
                  электрической энергии №&nbsp;
                  {props.data.contentDevicenumber ? (
                    <p style={{minWidth: '150px', textAlign: 'center', margin: 0, borderBottom: '1px solid black'}}>
                      {props.data.contentDevicenumber}
                    </p>
                  ) : (
                    '______________________'
                  )}
                </b>
              </h4>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <p>
              «
              <span
                style={{width: '48px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.day}
              </span>
              » &nbsp;&nbsp;
              <span
                style={{width: '54px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.month}
              </span>
              &nbsp;20
              <span
                style={{width: '36px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.year}
              </span>
              &nbsp;г.
            </p>
            <p>
              «
              <span
                style={{width: '36px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.hours}
              </span>
              »&nbsp;&nbsp;часов&nbsp;«
              <span
                style={{width: '30px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
              >
                {props.data.minutes}
              </span>
              »&nbsp;&nbsp;минут
            </p>
          </div>
        </header>
        <main>
          <div>
            <div>
              <p>
                Составлен представителем гарантирующего поставщика ООО «ЭМС», действующим на основании доверенности
                №&nbsp;
                <span
                  style={{
                    width: '148px',
                    display: 'inline-block',
                    textAlign: 'center',
                    borderBottom: '1px solid black',
                  }}
                >
                  147-1/2024
                </span>
                &nbsp;от&nbsp;«
                <span
                  style={{width: '20px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
                >
                  16
                </span>
                »&nbsp;
                <span
                  style={{width: '36px', display: 'inline-block', textAlign: 'center', borderBottom: '1px solid black'}}
                >
                  мая
                </span>
                &nbsp;2024г.
              </p>
            </div>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <p style={{margin: 0, display: 'inline-flex', flexDirection: 'row', alignItems: 'center'}}>
                в лице:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span style={{margin: 0, width: '90%', borderBottom: '1px solid black', fontSize: '16px'}}>
                  {props.data.userFio}
                </span>
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: '16px',
                  display: 'inline-flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                }}
              >
                <i>(должность, ФИО)</i>
              </p>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: '5px',
              alignItems: 'flex-end',
            }}
          >
            <p style={{margin: 0, display: 'inline-block', width: '145px', textWrap: 'wrap'}}>
              в отношении <b>потребителя</b>
            </p>
            <p
              style={{
                margin: 0,
                display: 'inline-block',
                height: 'fit-content',
                flex: 0.45,
                borderBottom: '1px solid black',
                fontSize: '16px',
              }}
            >
              {props.data.customer}
            </p>
            <p style={{margin: 0}}>
              <b>лицевой счёт</b>
            </p>
            <p style={{margin: 0, flex: 0.45, borderBottom: '1px solid black', fontSize: '16px'}}>
              {props.data.idLicAccount}
            </p>
          </div>
          <div style={{display: 'flex', flexDirection: 'column', marginTop: '5px'}}>
            <p style={{display: 'inline-flex', flexDirection: 'row', gap: '10px'}}>
              по адресу:
              <span style={{margin: 0, display: 'inline-flex', flex: 0.45, justifyContent: 'space-between'}}>
                <b>нас. пункт</b>
                <span
                  style={{margin: 0, flex: 0.8, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}
                >
                  {props.data.city}
                </span>
              </span>
            </p>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <p style={{margin: 0}}>
                <b>ул.</b>
              </p>
              <p style={{margin: 0, flex: 0.35, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}>
                {props.data.street}
              </p>
              <p style={{margin: 0}}>
                <b>д.</b>
              </p>
              <p style={{margin: 0, flex: 0.15, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}>
                {' '}
                {props.data.house}
              </p>
              <p style={{margin: 0}}>
                <b>корп.</b>
              </p>
              <p
                style={{margin: 0, flex: 0.1, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}
              ></p>
              <p style={{margin: 0}}>
                <b>кв.</b>
              </p>
              <p style={{margin: 0, flex: 0.15, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}>
                {' '}
                {props.data.apartment}
              </p>
              <p style={{margin: 0}}>
                <b>комн.</b>
              </p>
              <p
                style={{margin: 0, flex: 0.1, borderBottom: '1px solid black', paddingLeft: '5px', fontSize: '16px'}}
              ></p>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: '5px',
            }}
          >
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '49%'}}>
              <p style={{margin: 0}}>
                <b>телефон потребителя:</b>
              </p>
              <p style={{margin: 0, flex: 0.9, borderBottom: '1px solid black', fontSize: '16px'}}>
                {props.data.customerPhone}
              </p>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '49%'}}>
              <p style={{margin: 0}}>
                <b>e-mail потребителя:</b>
              </p>
              <p style={{margin: 0, flex: 0.9, borderBottom: '1px solid black'}}>{props.data.email}</p>
            </div>
          </div>
          <p style={{margin: '2px 0', fontSize: '16px'}}>Характеристики и показания прибора учета электроэнергии:</p>
          <div style={{width: '100%', height: 'fit-content'}}>
            <table style={{border: '1px solid black', borderCollapse: 'collapse', fontSize: '16px', width: '100%'}}>
              <thead>
                <tr style={{width: '100%'}}>
                  <th
                    style={{
                      width: '33%',
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '6px 0',
                      backgroundColor: '#f2f2f2',
                    }}
                  ></th>
                  <th
                    style={{
                      width: '33%',
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '6px 0',
                      backgroundColor: '#f2f2f2',
                    }}
                  >
                    Демонтирован ИПУ
                  </th>
                  <th
                    style={{
                      width: '33%',
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '6px 0',
                      backgroundColor: '#f2f2f2',
                    }}
                  >
                    Установлен ИПУ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Место установки
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {props.data.taskLocation}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.taskLocation}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Балансовая принадлежность
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    ООО «РКС - энерго»
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Тип
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.devicename}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    Милур 107S.22 - GRZ - 1L - DT
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Заводской номер
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.devicenumber}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentDevicenumber}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Класс точности
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    0.5S
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Показания
                  </td>
                  <td style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                    <span style={{display: 'inline-flex', width: '100%', flexWrap: 'nowrap'}}>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '40%',
                        }}
                      >
                        ∑: {props.data.contentSummaOld}
                      </span>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '35%',
                        }}
                      >
                        Т1: {props.data.contentT1Old}
                      </span>
                      <span style={{fontSize: '16px', padding: '3px', display: 'inline-block', width: '25%'}}>
                        Т2: {props.data.contentT2Old}
                      </span>
                    </span>
                  </td>
                  <td style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                    <span style={{display: 'inline-flex', width: '100%', flexWrap: 'nowrap'}}>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '40%',
                        }}
                      >
                        ∑: {props.data.contentSumma}
                      </span>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '35%',
                        }}
                      >
                        Т1: {props.data.contentT1}
                      </span>
                      <span style={{fontSize: '16px', padding: '3px', display: 'inline-block', width: '25%'}}>
                        Т2: {props.data.contentT2}
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Разрядность (до и после запятой)
                  </td>
                  <td style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                    <span style={{display: 'inline-flex', width: '100%', flexWrap: 'nowrap'}}>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '50%',
                        }}
                      >
                        До:
                      </span>
                      <span style={{fontSize: '16px', padding: '3px', display: 'inline-block', width: '50%'}}>
                        После:
                      </span>
                    </span>
                  </td>
                  <td style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                    <span style={{display: 'inline-flex', width: '100%', flexWrap: 'nowrap'}}>
                      <span
                        style={{
                          fontSize: '16px',
                          borderRight: '1px solid black',
                          borderCollapse: 'collapse',
                          padding: '3px',
                          display: 'inline-block',
                          width: '50%',
                        }}
                      >
                        До: 6
                      </span>
                      <span style={{fontSize: '16px', padding: '3px', display: 'inline-block', width: '50%'}}>
                        После: 2
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Год выпуска
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.productdate}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentProductdate}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Дата поверки
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.lastControlDate}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentLastControlDate}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Дата следующей поверки
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.nextControlDate}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentNextControlDate}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Iном, А / Uном, В
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    5(100) / А 230 В
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Пломба №
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentSealnumberOld}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentSealnumber}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    Организация, установившая пломбу
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    ООО «РКС - энерго»
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      padding: '3px',
                      paddingLeft: '7.5px',
                    }}
                  >
                    № телефона SIM карты{' '}
                  </td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  ></td>
                  <td
                    style={{border: '1px solid black', borderCollapse: 'collapse', padding: '3px', textAlign: 'center'}}
                  >
                    {' '}
                    {props.data.contentSimNumber}
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                border: '1px solid black',
                borderTop: 0,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  flex: 0.265,
                  paddingLeft: '7.5px',
                }}
              >
                <span>
                  <b>Причина замены (установки):</b>
                </span>
              </div>
              <div style={{display: 'flex', flexDirection: 'column', flex: 0.6}}>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  <input style={{height: '20px', width: '20px'}} type="checkbox" />
                  <p style={{margin: 0}}>истечение МПИ&nbsp;</p>
                  <input style={{height: '20px', width: '20px'}} type="checkbox" />
                  <p style={{margin: 0}}>выход из строя&nbsp;</p>
                  <input style={{height: '20px', width: '20px'}} type="checkbox" />
                  <p style={{margin: 0}}>ПУ отсутствует&nbsp;</p>
                  <input style={{height: '20px', width: '20px'}} type="checkbox" />
                  <p style={{margin: 0}}>иное:&nbsp;</p>
                </div>
                <span>п. 80(1) ПП №354 от 06.05.2011 и п. 136 ПП № 442 от 04.05.2012</span>
              </div>
            </div>
          </div>
          <div style={{marginTop: '10px'}}>
            <span>
              <p style={{margin: 0, fontSize: '16px'}}>
                <b>Решение о вводе в эксплуатацию:</b> Установленный прибор учета&nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" checked={true} />
                &nbsp;<b>соответствует</b>&nbsp;/&nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" />
                &nbsp;<b>не соответствует</b>&nbsp;требованиям, предъявляемым нормативными документами к средствам
                учета, и &nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" checked={true} />
                &nbsp;<b>принимается</b>&nbsp;/&nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" />
                &nbsp;<b>не может быть введен</b>&nbsp; в эксплуатацию по причине:
              </p>
            </span>
            <span>
              __________________________________________________________________________________________________________________________________
            </span>
          </div>
          <div>
            <span>
              <p style={{margin: 0, fontSize: '16px'}}>
                <b>Характеристики соответствия:</b>&nbsp;Пломбы поверителя на установленном приборе учета соответствуют
                оттиску в свидетельстве о поверке и (или) записи в паспорте (формуляре) средства измерений и месту
                установки контрольных пломб и знаков визуального контроля, установленных на день начала проверки.
              </p>
            </span>
          </div>
          <div>
            <span>
              <p style={{margin: 0, fontSize: '16px'}}>
                <b>Особые отметки:</b>&nbsp;Прибор учета &nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" checked={true} />
                &nbsp;<b>включен</b>&nbsp;/&nbsp;
                <input style={{height: '20px', width: '20px', margin: 0}} type="checkbox" />
                &nbsp;<b>не включен</b>&nbsp; в ИСУЭ ООО «РКС-энерго».
              </p>
            </span>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <span style={{padding: '1px', display: 'inline-flex', alignItems: 'flex-end'}}>
                <p style={{margin: 0, fontSize: '16px'}}>
                  Электронная почта Потребителя для направления уведомления о присоединении прибора учета электрической
                </p>
              </span>
              <span
                style={{
                  padding: '1px',
                  display: 'inline-flex',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between',
                }}
              >
                <p style={{margin: 0, flex: 0.5}}>
                  энергии к интеллектуальной системе учета электрической энергии (мощности)
                </p>
                <p style={{margin: 0, borderBottom: '1px solid black', flex: 0.45}}></p>
              </span>
            </div>
            <span>
              <p style={{margin: 0, fontSize: '16px'}}>В ходе проверки производилась фото / видеофиксация.</p>
            </span>
          </div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
              <p style={{margin: 0}}>
                <b>Представитель ООО «РКС-энерго»</b>
              </p>
              <div style={{width: '60%'}}>
                <span
                  style={{
                    width: '100%',
                    borderBottom: '1px solid black',
                    display: 'inline-flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <p style={{margin: 0}}>
                    <b>
                      (&nbsp;&nbsp;
                      {props.data.userFio
                        .split(' ')
                        .map((i: any, index: any) => (index !== 0 ? i[0] + '.' : i))
                        .join(' ')}
                      &nbsp;&nbsp;)
                    </b>
                  </p>
                </span>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '16px'}}>
                      <i>(подпись)</i>
                    </p>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '16px'}}>
                      <i>(расшифровка подписи, ФИО)</i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px'}}>
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <p style={{margin: 0, textWrap: 'balance'}}>
                  <b>Представитель исполнителя коммунальных услуг</b>
                </p>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '16px'}}>
                    <i>(при участии)</i>
                  </p>
                </div>
              </div>
              <div style={{width: '60%'}}>
                <span
                  style={{
                    width: '100%',
                    borderBottom: '1px solid black',
                    display: 'inline-flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <p style={{margin: 0, letterSpacing: 3}}>
                    <b>
                      (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                    </b>
                  </p>
                </span>
                <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '16px'}}>
                      <i>(подпись)</i>
                    </p>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                    <p style={{margin: 0, fontSize: '16px'}}>
                      <i>(расшифровка подписи, ФИО)</i>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span>
            <p style={{margin: '4px 0 0 0'}}>
              Один экземпляр акта получил, демонтированный прибор учета получил, порядок снятия показаний разъяснен.
            </p>
          </span>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <p style={{margin: 0}}>
              <b>Потребитель (представитель)</b>
            </p>
            <div style={{width: '60%'}}>
              <span
                style={{
                  width: '100%',
                  borderBottom: '1px solid black',
                  display: 'inline-flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  height: '16px',
                }}
              >
                <p style={{margin: 0, fontSize: '16px'}}>
                  <b>(&nbsp;{props.data.customer}&nbsp;)</b>
                </p>
              </span>
              <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '16px'}}>
                    <i>(подпись)</i>
                  </p>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', width: '50%', justifyContent: 'center'}}>
                  <p style={{margin: 0, fontSize: '16px'}}>
                    <i>(расшифровка подписи, ФИО)</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px'}}>
            <p style={{margin: 0}}>Причина отказа от подписания акта:</p>
            <p style={{margin: 0}}>
              ___________________________________________________________________________________________
            </p>
          </div>
        </main>
      </div>
    </div>
  );
};
